export const params = [
  { id: 1, name: 'Дата назначения' },
  { id: 2, name: 'Статус' },
  { id: 3, name: 'Комментарий' },
  { id: 4, name: 'Статус оплаты' },
  { id: 5, name: 'Мастер' },
  { id: 6, name: 'Исполнитель' },
  { id: 7, name: 'Признаки' },
  { id: 8, name: 'Стадия помещения' },
];

export const modalIds = {
  executeDateTime: 1,
  state: 2,
  comment: 3,
  paymentState: 4,
  master: 5,
  executor: 6,
  sign: 7,
  stageRequest: 8,
};
